var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMonthlyVictoriesIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.5526V3.19873C1 1.72105 2.54728 0.753614 3.87576 1.40066L14.5989 6.62346C16.0433 7.32696 16.1106 9.36031 14.7158 10.1578L3.99272 16.2889C2.6594 17.0512 1 16.0885 1 14.5526Z",
    fill: "#FFBE00",
    stroke: "#FFBE00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMonthlyVictoriesIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Monthly_Victories_Icon.2a8e41a3.svg";
export { ForwardRef as ReactComponent };